// Canned openers for the mood row. Fixed text, written by us: no model call, nothing stored.
// A mood tap is not a crisis signal; crisis detection stays on the text the student types.
export const MOODS = [
  {
    id: "rough",
    label: "Rough",
    opener: "Sounds like a heavy day. Want to tell me what happened, or would a minute of breathing help first?",
    chips: ["Talk it through", "Breathing exercise", "Just vent"],
  },
  {
    id: "meh",
    label: "Meh",
    opener: "Some days are just flat. Anything on your mind, or do you want a small distraction?",
    chips: ["Something on my mind", "Distract me", "Breathing exercise"],
  },
  {
    id: "ok",
    label: "OK",
    opener: "Glad you're steady. What would make today a little better?",
    chips: ["Make today better", "Plan my day", "Just chat"],
  },
  {
    id: "good",
    label: "Good",
    opener: "Nice, I'm glad. What's going well?",
    chips: ["Tell you what's good", "Plan my week", "Just chat"],
  },
  {
    id: "great",
    label: "Great",
    opener: "Love that. What's got you feeling this way?",
    chips: ["Tell you why", "Plan my week"],
  },
];

export const STARTERS = ["I need to vent", "Calm my nerves", "Just chat"];

export function getMood(id) {
  return MOODS.find((m) => m.id === id) || null;
}
